module.exports = __webpack_public_path__ + "static/media/logo192x192.d8a75c74.png";